import { __extends } from "../../../config/javascript.js"
import { decodeUtf8 } from 'base/backbone/lib/utilities/helpers';


Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.Collection = Backbone.Collection.extend({
        onLoadingStart: function() {
            this.loading = true;
            this.trigger('loading:start');
        },
        onLoadingStop: function() {
            this.loading = false;
            this.trigger('loading:stop');
        },
        sliced: function(from, num) {
            var collection = this;
            collection = _(collection.rest(from));
            collection = _(collection.first(num));
            return collection.map(function(model) {
                return model;
            });
        },
        decode_utf8: decodeUtf8,
        constructor: function(models, options) {
            options = options || {};
            if (options.url) {
                this.url = options.url;
            }
            this.loading = false;
            Backbone.Collection.prototype.constructor.apply(this, arguments);

            this.listenTo(this, {
                'sync': this.onLoadingStop.bind(this),
                'error': this.onLoadingStop.bind(this),
                'request': this.onLoadingStart.bind(this),
            });
        }
    });
    Entities.ClientPaginatedCollection = Backbone.Paginator.clientPager.extend({
        paginator_ui: {
            firstPage: 1,
            currentPage: 1,
            perPage: 30,
            totalPages: 10
        },
        paginator_core: {
            type: 'GET',
            dataType: 'JSON',
            cache: true
        }
    });

    Entities.FilterableCollection = Entities.Collection.extend({
        clearFilterCriterias: function() {
            this._currentCriteria = false;
            this._originalModels = null;
        },
        filterBy: function(criterias, resetOriginal) {
            var items;
            var _this = this;
            if (_.isFalsy(this._currentCriteria) || !_.isFalsy(resetOriginal)) {
                this._originalModels = this.models;
                this._remaining_count = this.remaining_count;
            }
            // call 'where' if we have criteria
            // or just get all the models if we don't
            if (criterias) {
                items = [];

                _.each(this._originalModels, function(model) {
                    for (var criteria in criterias) {
                        if (decodeUtf8(model.get(criteria).toLowerCase()).indexOf(criterias[criteria].toLowerCase()) != -1) {
                            items.push(model);
                        }
                    }
                });
                // store current criteria
                this._currentCriteria = criterias;
                this.remaining_count = items.length;
            } else {
                items = this._originalModels;
                this.clearFilterCriterias();
                this.remaining_count = this._remaining_count;
            }

            // reset the filtered collection with the new items
            this.reset(items);
            this.trigger('collection:filtered');
        }
    });

    Entities.PaginatedCollection = (function(_super) {
        __extends(Base, _super);

        function onLoadingStart() {
            this.loading = true;
            this.trigger('loading:start');
        }

        function onLoadingStop() {
            this.loading = false;
            this.trigger('loading:stop');
        }

        function Base(modelArray, options) {
            var _this = this;
            options = options || {};
            this.paginator_core = this.paginator_core || {};
            this.paginator_ui = this.paginator_ui || {};
            this.server_api = this.server_api || {};
            //session changes every 20 minutes
            this.sessionId = Math.floor(Date.now() / 600000) + '';
            this.previousXhr = null;
            //if we want perfect randomness
            //this.sessionId = Date.now() + Math.random().toString(36).substr(2);

            _.defaults(this.paginator_core, {
                type: 'GET',
                dataType: 'JSON',
                url: _.result(options, 'url'),
                cache: true
            });
            _.defaults(this.paginator_ui, {
                firstPage: 1,
                currentPage: 1,
                perPage: 30,
                totalPages: 10
            });
            if (gon.isMobileDevice) {
                this.paginator_ui.perPage = 10;
            }
            this.album = options.album;
            this.sort = options.sort;
            this.filter = options.filter;
            this.loading = false;
            Base.__super__.constructor.call(this, modelArray, options);

            this.listenTo(this, {
                'sync': onLoadingStop,
                'error': onLoadingStop,
                'request': onLoadingStart,
            });
        }
        Base.prototype.decode_utf8 = decodeUtf8;
        Base.prototype.goTo = function(page, options) {
            if (this.previousXhr) {
                this.previousXhr.abort();
            }
            this.previousXhr = Backbone.Paginator.requestPager.prototype.goTo.call(this, page, options);
            return this.previousXhr;
        };

        return Base;
    })(Backbone.Paginator.requestPager);
});
